import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { HousingAssistance } from '../components/shared/HousingAssistance';

export const Route = createFileRoute('/shire/$name_/housing')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Housing',
      'Housing assistance, social housing and community housing providers in this shire.',
    ),
  component: HousingPage,
});

function HousingPage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Housing"
      title="Housing assistance"
      lede={`Help finding affordable, social and community housing in the Shire of ${shire.name}.`}
    >
      <HousingAssistance shireId={shire.id} />
    </ShireSubPageShell>
  );
}
